// extracted by mini-css-extract-plugin
export default {"heroSection":"TeamView_heroSection__d6Js4","teamGrid":"TeamView_teamGrid__pV9+s"};